module.exports = __webpack_public_path__ + "img/462.9bc95b23.png";